import styles from './button.module.scss';
import formFooterStyles from '../form_footer/form_footer.module.scss';
import {Link} from 'react-router-dom';
import React from 'react';
import {classNames} from '../../support/classnames';
import {ButtonPosition} from '../../enums/button_position.ts';
import {ButtonColorType} from '../../enums/button_color_type.ts';
import {Alignment} from '../../enums/alignment.ts';

interface OwnProps {
    className?: string;
    to?: string;
    href?: string;
    type?: 'button' | 'submit' | 'reset';
    colorType?: ButtonColorType;
    customColor?: string;
    position?: ButtonPosition;
    disabled?: boolean;
    noBorder?: boolean;
    noIcon?: boolean;
    loading?: boolean;
    preventScrollReset?: boolean;
    onClick?: () => void;
    children: React.ReactNode;
    target?: string;
    iconPosition?: Alignment;
}

export function Button({
    className,
    to,
    href,
    type,
    colorType,
    customColor,
    position,
    children,
    disabled,
    loading,
    preventScrollReset,
    noBorder,
    noIcon,
    onClick,
    target,
    iconPosition,
}: OwnProps) {
    const buttonStyle = customColor
        ? {
              borderColor: customColor,
              color: customColor,
          }
        : undefined;

    if (to) {
        return (
            <Link
                to={to}
                className={classNames(className, styles.button, {
                    [styles.disabled]: disabled,
                    [styles.loading]: loading,
                    [styles.no_border]: noBorder,
                    [styles.no_icon]: noIcon,
                    [styles.icon_right]: iconPosition === Alignment.End,
                    [styles.black]: colorType === ButtonColorType.Black,
                    [styles.green]: colorType === ButtonColorType.Green,
                    [formFooterStyles.left]: position === ButtonPosition.Left,
                    [formFooterStyles.right]: position === ButtonPosition.Right,
                })}
                style={buttonStyle}
                preventScrollReset={preventScrollReset ?? false}
                target={target ?? undefined}
                viewTransition={true}
            >
                {children}
            </Link>
        );
    }

    if (href) {
        return (
            <a
                href={href}
                className={classNames(className, styles.button, {
                    [styles.disabled]: disabled,
                    [styles.loading]: loading,
                    [styles.no_border]: noBorder,
                    [styles.no_icon]: noIcon,
                    [styles.icon_right]: iconPosition === Alignment.End,
                    [styles.black]: colorType === ButtonColorType.Black,
                    [styles.green]: colorType === ButtonColorType.Green,
                    [formFooterStyles.left]: position === ButtonPosition.Left,
                    [formFooterStyles.right]: position === ButtonPosition.Right,
                })}
                style={buttonStyle}
                target={target ?? undefined}
                onClick={onClick}
            >
                {children}
            </a>
        );
    }

    return (
        <button
            className={classNames(className, styles.button, {
                [styles.disabled]: disabled,
                [styles.loading]: loading,
                [styles.no_border]: noBorder,
                [styles.no_icon]: noIcon,
                [styles.icon_right]: iconPosition === Alignment.End,
                [styles.black]: colorType === ButtonColorType.Black,
                [styles.green]: colorType === ButtonColorType.Green,
                [formFooterStyles.left]: position === ButtonPosition.Left,
                [formFooterStyles.right]: position === ButtonPosition.Right,
            })}
            style={buttonStyle}
            type={type ?? 'submit'}
            disabled={disabled}
            onClick={onClick}
        >
            {children}
        </button>
    );
}
